import React from "react";
import ContactUs from "./../components/contact";
import FAQSection from "../components/faq";
import FooterCTA from "../components/footer";
import HeroSection from "../components/heroSection";
import Services from "../components/services";
import Features from "../components/features";
import AboutUs from "../components/aboutUs";
import Header from "../components/header";


import { useLocation } from "react-router-dom";
import { useEffect } from "react";

function Landing() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.substring(1));
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100);
      }
    }
  }, [hash]);

  return (
    <div className="bg-white overflow-x-hidden">
      <Header />

      {/* Hero Section */}
      <main id="home" className="bg-white px-2 md:px-4">
        <HeroSection />
      </main>

      {/* Our Services Section */}
      <Services />

      {/* Explore Our Amazing Features Section */}
      <Features />

      {/* About Section */}
      <AboutUs />

      <FAQSection id="faq-section" />
      <ContactUs id="contact-section" />

      <FooterCTA />
    </div>
  );
}

export default Landing;
